<template>
    <div class="Loading">
        <p>Loading the Solar System…</p> 
        <Icon :icon="loadingIcon.icon" :size="loadingIcon.size"/>
    </div>
</template>

<script>
    import Icon, { ICONS, SIZES } from './Icon.vue';

    export default {
        props: {
            progress: {
                type: Object,
            },
        },
        components: { Icon },
        data: () => ({
            loadingIcon: {
                icon: ICONS.get('spinner'),
                size: SIZES.get('large'),
            },
        }),
    };
</script>


<style scoped>
    .Loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        height: 100vh;
    }
</style>